<template>
  <div class="section">
    <div class="section-title">Csomag részletei</div>
    <div class="section-content">
      <b-form-group
        label-cols="4"
        label="Név"
      >
        <div class="form-control" readonly>
          <span>{{ selectedPackage.name }}</span>
        </div>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Ismétlődő"
      >
        <b-checkbox
          v-model="selectedPackage.is_recurring"
          disabled
        ></b-checkbox>
      </b-form-group>
      <b-form-group
        label-cols="4"
        :label="limitName(limit.type)"
        v-for="(limit, index) in selectedPackage.limitations"
        :key="index"
      >
        <div class="form-control" readonly>
          <span v-html="limitAmount(limit.amount)"></span>
        </div>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Ár"
      >
        <b-input-group>
          <b-input id="price" :value="selectedPackage.price" readonly/>
          <b-input-group-append>
            <b-input-group-text>Ft</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Havidíj"
      >
        <b-input-group>
          <b-input id="recurring_price" :value="selectedPackage.recurring_price" readonly/>
          <b-input-group-append>
            <b-input-group-text>Ft</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Próbaidőszak kedvezmény"
      >
        <b-input-group>
          <b-input id="trial_discount" :value="Math.round(selectedPackage.trial_discount * 100)" readonly/>
          <b-input-group-append>
            <b-input-group-text>%</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Próbaidőszak hossza"
      >
        <b-input-group>
          <b-input id="trial_length_months" :value="selectedPackage.trial_length_months" readonly/>
          <b-input-group-append>
            <b-input-group-text>hónap</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label="Érvényesség hossza"
      >
        <b-input-group>
          <b-input id="validity_length_months" :value="selectedPackage.validity_length_months" readonly/>
          <b-input-group-append>
            <b-input-group-text>hónap</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import emptyPackage from './_package'

export default {
  props: {
    selectedPackage: {
      type: Object,
      required: true,
      default: emptyPackage
    }
  },
  computed: {
    trialDiscount() {
      return `${this.selectedPackage.trial_discount * 100}%`
    }
  },
  methods: {
    toPercent(ratio) {
      return `${ratio * 100}%`
    },
    limitName(type) {
      switch(type) {
        case 'test_campaign_creation':
          return 'Aktiválható kampányok száma'
        case 'test_rating':
          return 'Tesztek száma'
        default:
          return type
      }
    },
    limitAmount(amount) {
      if(amount === -1) {
        return '&infin;'
      } else {
        return amount
      }
    }
  }
}
</script>